import type { FunctionComponent } from 'react';
import { useCallback, useEffect } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { betActions } from '../../store/slices/bets/slice';

import { BetOverrider } from './BetOverrider';

export const BetOverriderConnector: FunctionComponent = (): null => {
  const dispatch = useCoreDispatch();

  const handleTotalBetOverriderChange = useCallback(() => {
    dispatch(betActions.recalculateTotalBet());
  }, [dispatch]);

  useEffect(() => {
    BetOverrider.onTotalBetOverriderChange(handleTotalBetOverriderChange);
    return (): void => {
      BetOverrider.onTotalBetOverriderChange(null);
    };
  }, [handleTotalBetOverriderChange]);

  return null;
};
